import { Component, input, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';
import { SelectButtonModule } from 'primeng/selectbutton';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { InputText } from 'primeng/inputtext';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { AddressSearchMode } from '../../../_formly/_types/address-search.controller';
import { AddressSuggestion } from '../../../_services/address-cabina-search.service';

/**
 * Pannello di ricerca condiviso da select-field/multiselect-field: toggle
 * [Cabina/Città] [Indirizzo] + input con suggerimenti Google Places.
 */
@Component({
  selector: 'app-address-search-panel',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    TranslatePipe,
    SelectButtonModule,
    IconFieldModule,
    InputIconModule,
    InputText,
    ProgressSpinnerModule,
  ],
  templateUrl: './address-search-panel.component.html',
  styleUrl: './address-search-panel.component.scss',
})
export class AddressSearchPanelComponent {
  readonly mode = input.required<AddressSearchMode>();
  readonly query = input('');
  readonly suggestions = input<AddressSuggestion[]>([]);
  readonly loading = input(false);
  readonly placesUnavailable = input(false);
  /** true quando un indirizzo è già stato risolto: sopprime "nessun indirizzo trovato". */
  readonly resolved = input(false);

  readonly modeChange = output<AddressSearchMode>();
  readonly queryChange = output<string>();
  readonly suggestionSelected = output<AddressSuggestion>();

  readonly modeOptions: { label: string; value: AddressSearchMode }[] = [
    { label: 'formly.address_search.mode.options', value: 'options' },
    { label: 'formly.address_search.mode.address', value: 'address' },
  ];

  onModeChange(mode: AddressSearchMode): void {
    this.modeChange.emit(mode);
  }

  onQueryInput(value: string): void {
    this.queryChange.emit(value);
  }

  onSuggestionClick(suggestion: AddressSuggestion): void {
    this.suggestionSelected.emit(suggestion);
  }
}
